import React, { useEffect, useState } from 'react';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { Button } from '../../../Elements';
import clsx from 'clsx';
import { useMediaQuery } from 'utils/hooks/useMediaQuery';
import { useScrollInfo } from 'utils/hooks/useScrollInfo';

const Badge = ({ v, active, opacity, value, onChange }) => (
  <div className={clsx('flex w-full', opacity)}>
    <div
      className={clsx(
        'w-full',
        'group flex items-center cursor-pointer',
        'flex-row',
        'py-2 pl-4 pr-8 md:p-8',
        'space-y-0',
        'space-x-4 md:space-x-8',
        'border',
        'rounded-full md:rounded-xl',
        {
          'bg-white': !value,
          'bg-redChristmas': active,
        }
      )}
      onClick={() => onChange(active ? undefined : v.value)}>
      <div className={'md:hidden w-10'}>
        <Label
          text={v.value}
          color={active ? { classname: 'white' } : undefined}
          weight={'bold'}
        />
      </div>
      <div className='md:hidden text-left cursor-pointer text-sm'>
        <Label
          text={' | '}
          color={active ? { classname: 'white' } : undefined}
        />
      </div>
      <div className='md:hidden text-left cursor-pointer flex-1 text-sm'>
        <Label
          text={v?.label?.text}
          color={active ? { classname: 'white' } : undefined}
        />
      </div>

      <div className={'hidden md:block w-16'}>
        <Button
          color={{ classname: 'white' }}
          // isCrossed={!isSelectedDiopterAvailable}
          label={{ text: v.value, align: 'text-left' }}
          // onClick={() => onDiopterChange(v.selectedOptions.diopter)}
          size={'base'}
          type='contained'
          fullWidth
        />
      </div>

      <div className='hidden md:block text-left ml-2 cursor-pointer flex-1 text-sm'>
        <Label
          text={v?.label?.text}
          weight={'bold'}
          color={active ? { classname: 'white' } : undefined}
        />
        <Label
          text={v?.subLabel?.text}
          color={active ? { classname: 'white' } : undefined}
        />
      </div>

      <div
        className={clsx('hidden md:block border rounded-full p-1', {
          'bg-white': active,
        })}>
        {active ? (
          <Icon iconKey='HiOutlineCheck' />
        ) : (
          <Icon iconKey='HiOutlineX' />
        )}
      </div>
    </div>
  </div>
);

const VerticalDisplay = ({ options, value, onChange }) => (
  <div
    className={clsx(
      'justify-center',
      'max-w-lg',
      'flex-1',
      'flex',
      'flex-col',
      'items-center',
      'space-y-4'
    )}>
    {options.map((v) => {
      const active = value === v.value;
      const opacity = value && !active ? 'opacity-50' : null;

      return (
        <Badge
          key={v.value}
          {...{ v, active, opacity, value, onChange }}
        />
      );
    })}
  </div>
);

export const BadgeSelect = ({
  label,
  type,
  color,
  value,
  values: options,
  onChange,
}) => {
  return (
    <>
      <div className={'px-8'}>
        <Label
          {...label}
          align='text-center'
          size='3xl'
          color={{ classname: 'gray-800' }}
        />
      </div>
      <div
        className={
          'mt-8 flex flex-1 flex-col items-center justify-center w-full'
        }>
        <VerticalDisplay
          options={options}
          value={value}
          onChange={onChange}
        />
      </div>
    </>
  );
};
